import React from 'react';

const MainServicesArray = [
  { label: 'Carpentry' },
  { label: 'Bathrooms' },
  { label: 'Groundworks' },
];

function BottomBar() {
  return (
    <section className='grid w-full h-fit bg-colour4 border-b-2 border-solid border-colour6 full_shadow_black_invert_thin'>
      <div className='grid grid-cols-3 justify-evenly py-1 px-2 lg:px-12'>
        {MainServicesArray.slice(0, 3).map((service) => (
          <div key={service.label} className='grid text-center'>
            <span className='font-medium text-xs text-colour8'>{service.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default BottomBar;
